import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { LayerConfig } from '../ui/LayerConfig'
import { LayerSourceType } from '@/enum/LayerSourceType'
import { transformExtent } from 'ol/proj'


export interface IAloDbMapLayerConstParam extends IAloDbBaseConstParam {
    LAY_ID:number|null
    ENS_ID:number|null
    MIS_ID:number|null
    MIG_ID:number|null
    LAY_SCOPE:string|null    
    LAY_LIBELLE:string|null
    LAY_GROUP_NAME:string|null
    LAY_CONFIG_JSON:string|null
    LAY_DATA:string|null
    MISSION_IDS:number[]|null
    MISSION_GLOBALE_IDS:number[]|null
  }

export class AloDbMapLayer extends AloDbBase {
        
    public LAY_ID:number|null
    public ENS_ID:number|null
    public MIS_ID:number|null
    public MIG_ID:number|null
    public LAY_SCOPE:string|null    
    public LAY_LIBELLE:string|null
    public LAY_GROUP_NAME:string|null
    public LAY_CONFIG_JSON:string|null
    public LAY_DATA:string|null
    public MISSION_IDS:number[]|null
    public MISSION_GLOBALE_IDS:number[]|null
    
    
    constructor({LAY_ID,ENS_ID,MIS_ID,MIG_ID,LAY_SCOPE,LAY_LIBELLE,LAY_GROUP_NAME,LAY_CONFIG_JSON,LAY_DATA,MISSION_IDS,MISSION_GLOBALE_IDS,...args }:IAloDbMapLayerConstParam = {} as IAloDbMapLayerConstParam) {
        super(args)
        this.LAY_ID = LAY_ID
        this.ENS_ID = ENS_ID
        this.MIS_ID = MIS_ID ?? null
        this.MIG_ID = MIG_ID ?? null
        this.LAY_SCOPE = LAY_SCOPE        
        this.LAY_LIBELLE = LAY_LIBELLE   
        this.LAY_GROUP_NAME = LAY_GROUP_NAME   
        this.LAY_CONFIG_JSON = LAY_CONFIG_JSON 
        this.LAY_DATA  = LAY_DATA        
        this.MISSION_IDS = MISSION_IDS ?? []
        this.MISSION_GLOBALE_IDS = MISSION_GLOBALE_IDS ?? []  
    }

    static createAloDbMapLayerArray(datas:any) {
        return new AloBaseArray(AloDbMapLayer,datas)
    }

    static createAloDbMapLayerWithDetail(data:any) {
        return new AloDbMapLayer({...data,detailLoaded:true})
    }

    static toOlLayerConfig = (id:number,config:LayerConfig ) => {
        if(!config) return null                
        
        if(config.type == LayerSourceType.WMTS) {            
                         

              Object.keys(config?.options ?? {}).forEach(key => {
                config.optionsWmts.dimensions[key] = config.options[key].default                
              })

              //@ts-ignore
              //config.optionsWmts.dimensions.range = config.colorscalemin!=null && config.colorscalemax != null?`${(Number.parseFloat(config.colorscalemin) + Number.parseFloat(config.colorscaleoffset))}/${(Number.parseFloat(config.colorscalemax) + Number.parseFloat(config.colorscaleoffset))}`:undefined

              let style = config.defaulStyle ?? 'default'
              
              if(config.colorscalemin!=null && config.colorscalemax != null){
                //@ts-ignore
                style = `${style},range:${(Number.parseFloat(config.colorscalemin) + Number.parseFloat(config.colorscaleoffset))}/${(Number.parseFloat(config.colorscalemax) + Number.parseFloat(config.colorscaleoffset))}`
              }
                                         

              const source =         {        
                cmp: 'vl-source-wmts',      
                url: config.url,                                   
                format:'image/png',    
                matrixSet: config.tileMatrix?? 'default028mm',
                styleName:  style, //config.defaulStyle ?? 'default',
                layerName: config.layer,                  
                dimensions: config.optionsWmts.dimensions
              } as any 
              

            return {
                isbaselayer: config.isBasic,
                id,  
                isWmts:(config.tileMatrix?.length ?? 0) > 0,                
                cmp: 'vl-layer-tile',                
                source
              }
        }
        else if(config.type == LayerSourceType.WMS) {
            
            const source:any = {
                cmp: 'vl-source-wms',
                //url: 'http://77.246.172.208/geoserver/emodnet/wms',
                url: config.url,     
                layers: config.layer,
                styles: config.defaulStyle ?? (config.styles.length == 0?null:config.styles[0])
              }

            const extParams:any = {
                version:'1.3.0',            
                format:'image/png',                       
                //@ts-ignore
                colorscalerange: config.colorscalemin!=null && config.colorscalemax != null?`${(Number.parseFloat(config.colorscalemin) + Number.parseFloat(config.colorscaleoffset))},${(Number.parseFloat(config.colorscalemax) + Number.parseFloat(config.colorscaleoffset))}`:undefined,                     
                transparent:true  
            }            

            Object.keys(config?.options ?? {}).forEach(key => {
                if(key != 'time') {
                    extParams[key] = config.options[key].default
                }
                else{                    
                    source.time = config.options[key].default
                }
            })

            source.extParams = extParams

            const layer = {
                isbaselayer: config.isBasic,
                id,  
                cmp: 'vl-layer-tile',
                source,                
              } as any
              //if(true) layer.extent = transformExtent([45.39570629539672, -12.833655414772672, 45.43571078834351, -12.810160579490024], 'EPSG:4326', 'EPSG:3857') 
              return layer
        }
        return null
    
    }
    
}
